import Vue from 'vue';
import marqueeDirective from './directive.js';
import marquee from './index.vue';
 const install = (vm)=>{
 	vm.directive('marquees', {bind:marqueeDirective});
	vm.component('Marquee', marquee);
 }

 export default{install}




// WEBPACK FOOTER //
// ./src/components/common-components/features/marquee/index.js